import React from 'react';
import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import {observer} from "mobx-react";
import {SVGImage} from "../../../../../core/components/image/svg-image";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";
import {BettingZoneMenuImageRequestParams} from "../assets/betting-zone-menu.image-request-params";

export const BettingZoneDrawerMenuItemLabels = observer(({item}) => {
  const assetsColor = useThemeColor(COLORS.textPrimary)

  const imageProps = {
    className: classNames(styles.item_icon),
    src: new BettingZoneMenuImageRequestParams(item.icon),
    alt: item.alt,
    fillcolor: assetsColor,
  }

  return <div className={classNames(styles.item_labels)}>
    <div className={classNames(styles.item_icon_container)}>
      <SVGImage {...imageProps}/>
    </div>
    {item.displayLabel}
  </div>
});